// ------------------------------------------------------------------------------
// name: status
// author: mudas
// created: 2025/7/11
// ------------------------------------------------------------------------------

// 工坊本身状态
export enum WorkshopStatus {
  ON_SHELF = 'ON_SHELF',
  PENDING_SHELF = 'PENDING_SHELF',
  CREATING = 'CREATING',
  DELETED = 'DELETED',
}

export const WorkshopStatusName = {
  [WorkshopStatus.ON_SHELF]: '运营中',
  [WorkshopStatus.PENDING_SHELF]: '未上架',
  [WorkshopStatus.CREATING]: '创建中',
  [WorkshopStatus.DELETED]: '已删除',
};

// 审核状态
export enum WorkshopReviewStatus {
  // 待审核
  PENDING = 0,

  // 审核通过
  APPROVED = 1,

  // 审核不通过
  REJECTED = 2,

  // 已撤回
  WITHDRAWN = 3,
}

export const WorkshopReviewStatusName = {
  [WorkshopReviewStatus.PENDING]: '待审核',
  [WorkshopReviewStatus.APPROVED]: '审核通过',
  [WorkshopReviewStatus.REJECTED]: '审核不通过',
  [WorkshopReviewStatus.WITHDRAWN]: '已撤回',
};

// 工坊推荐状态
export enum WorkshopRecommendStatus {
  // 使用中
  USING = 1,

  // 已到期
  EXPIRED = 2,

  // 已取消
  CANCELED = 3,
}

export const WorkshopRecommendStatusName = {
  [WorkshopRecommendStatus.USING]: '使用中',
  [WorkshopRecommendStatus.EXPIRED]: '已到期',
  [WorkshopRecommendStatus.CANCELED]: '已取消',
};

export enum RecommendSource {
  // 运营推荐
  OPERATION = 1,

  // 用户预约
  USER = 2,
}

export const RecommendSourceName = {
  [RecommendSource.OPERATION]: '运营推荐',
  [RecommendSource.USER]: '用户预约',
};

export enum TradingMode {
  // 定制品
  FIXED = 1,

  // 成品
  FINISHED = 2,
}

export const TradingModeName = {
  [TradingMode.FIXED]: '定制品',
  [TradingMode.FINISHED]: '成品',
};

// 使用许可类型：1 个人使用 2 商业使用 3与创作者协商使用
export enum LicenseType {
  // 个人使用
  PERSONAL = 1,

  // 商业使用
  BUSINESS = 2,

  // 与创作者协商使用
  NEGOTIATE = 3,
}

export const LicenseTypeName = {
  [LicenseType.PERSONAL]: '个人使用',
  [LicenseType.BUSINESS]: '商业使用',
  [LicenseType.NEGOTIATE]: '与创作者协商使用',
};

// 订单状态
export enum WorkshopOrderStatus {
  PENDING_PAYMENT = 1,
  PAYMENT_TIMEOUT = 2,
  PENDING_RECEIPT = 3,
  REQUEST_TO_CANCEL = 4,
  PROCESSING = 5,
  COMPLETED = 6,
  CLOSED = 7,
  REQUEST_TO_TERMINATE = 8,
}

export const WorkshopOrderStatusName = {
  [WorkshopOrderStatus.PENDING_PAYMENT]: '待支付',
  [WorkshopOrderStatus.PAYMENT_TIMEOUT]: '支付失败',
  [WorkshopOrderStatus.PENDING_RECEIPT]: '待确认接单',
  [WorkshopOrderStatus.REQUEST_TO_CANCEL]: '待确认接单-申请取消',
  [WorkshopOrderStatus.PROCESSING]: '进行中',
  [WorkshopOrderStatus.COMPLETED]: '已完成',
  [WorkshopOrderStatus.CLOSED]: '已退单',
  [WorkshopOrderStatus.REQUEST_TO_TERMINATE]: '进行中-申请退单',
};

export enum DeliveryMethod {
  ONLINE_DELIVERY = 1,
  EXPRESS_DELIVERY = 2,
  OFFLINE_PICKUP = 3,
}

export const DeliveryMethodName = {
  [DeliveryMethod.ONLINE_DELIVERY]: '线上交付',
  [DeliveryMethod.EXPRESS_DELIVERY]: '快递交付',
  [DeliveryMethod.OFFLINE_PICKUP]: '线下自提',
};
